import React from "react"
import Container from 'react-bootstrap/Container'


export default function info() {
    return (
        <Container as={"section"}>
            <div style={{color: "white"}}>Hello, I'm</div>
            <h1 className="display-2 color-accent" style={{fontWeight: "bold"}}>
                Carles Riera
            </h1>
            <h1 className="display-4 section-subtitle">
                I want to answer why Deep Neural Networks work
            </h1>
            <div className="mx-auto my-4 text-justify info ">
                <p>I am a Deep Learning indie predoc researcher at Universitat de Barcelona.</p>
                <p>I research in Neural Architecture Search, the Lottery Ticket Hypothesis and I’m particularly
                    interested in Minimum Width Networks and Zero Initializations.
                </p>
            </div>


        </Container>
    )
}
